import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LoadingButtonComponent } from '../buttons/loading/loading-button.component';

@Component({
  selector: 'app-async-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule, LoadingButtonComponent],
  templateUrl: './async-confirmation-dialog.component.html',
  styleUrl: './async-confirmation-dialog.component.scss',
})
export class AsyncConfirmationDialogComponent implements AfterViewInit {
  @ViewChild('dialog', { static: true }) dialog!: ElementRef<HTMLDialogElement>;

  @Input() title = 'Confirmar operación';
  @Input() message = '¿Desea proseguir con la operación?';
  @Input() confirmButtonText = 'Confirmar';
  @Input() confirmButtonIcon = 'check';
  @Input() isDeleteAction = false;
  @Input() hasCancelButton = false;
  @Input() cancelButtonText = 'Cancelar';
  @Input() cancelButtonIcon = 'close';
  @Input() loading = false;
  @Input() isOpen = false;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  ngAfterViewInit() {
    // Escuchar el evento close del diálogo nativo
    this.dialog.nativeElement.addEventListener('close', () => {
      this.handleDialogClose();
    });
  }

  ngOnChanges() {
    if (this.isOpen) {
      this.openModal();
    } else if (this.dialog?.nativeElement.open) {
      this.closeModal();
    }
  }

  openModal() {
    this.dialog.nativeElement.showModal();
  }

  closeModal() {
    if (this.dialog.nativeElement.open) {
      this.dialog.nativeElement.close();
    }
  }

  private handleDialogClose() {
    // Este método se ejecuta cuando el diálogo se cierra por cualquier razón
    // incluyendo ESC, backdrop click, o programáticamente
    this.closed.emit();
  }

  onConfirm() {
    this.confirmed.emit();
  }

  onCancel() {
    this.closeModal();
    this.cancelled.emit();
  }

  onBackdropClick(event: MouseEvent) {
    // Cerrar el modal si se hace clic en el backdrop
    if (event.target === this.dialog.nativeElement) {
      this.onCancel();
    }
  }
}
